import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import { Event, EventHTTPResponse } from '../models/event.model';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private http: HttpClient) {}

  getEvent(eventId: string): Observable<Event> {
    return this.http
      .get<EventHTTPResponse>(environment.API_URL + 'widget/event/' + eventId)
      .pipe(map((response: EventHTTPResponse) => response.data));
  }
}
